export default __webpack_public_path__ + "static/media/tbm-asset-plank-01.420c35ae.svg";